import {DvViewItem} from "@dv5/domain"
import {FC} from "react"
import {Icon, IconName} from "../buttons"
import './FavouriteOverview.less'

interface Props {
    item: DvViewItem
    onToggle?: () => void
}

export const FavouriteOverview: FC<Props> = ({item, onToggle}) => {
    if (!item.isFavourite) {
        return null
    }

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation()
        event.preventDefault()
        if (onToggle) {
            onToggle()
        }
    }

    return (
        <div
            className="favourite-overview is-favourite"
            title="Remove from favourites"
            onMouseDown={handleClick}
        >
            <Icon name={IconName.Star} width="20" height="20"/>
        </div>
    )
}
